import React from 'react';
import { Col } from '../../../../styles/common';
import { MESSAGES } from '../../utils/constants';
import { TextArea } from './styles';

interface AnswerTextAreaProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  disabled: boolean;
}

export const AnswerTextArea: React.FC<AnswerTextAreaProps> = ({ value, onChange, disabled }) => {
  return (
    <Col margin="24px 0" gap="8px" width="100%">
      <TextArea
        value={value}
        onChange={onChange}
        placeholder={MESSAGES.PLACEHOLDER}
        disabled={disabled}
        name="answer"
      />
    </Col>
  );
};
